module.exports = __webpack_public_path__ + "img/rightside_1000.e3962f45.jpg";